module.exports = __webpack_public_path__ + "static/media/sixteenth_viewpoint_bookstore3.a7783a83.png";